//--- Import Export Config here
export const WMS = "https://cargis.vn:8440/geoserver/nongnghiep2021/wms/";
export const APIUrl = "https://api-atlatvietnam.cargis.vn";
export const AdminUrl = "https://admin-atlatvietnam.cargis.vn";
export const UserUrl = "https://atlatvietnam.cargis.vn";

export const domainName = "";
const dateExpires = new Date();
dateExpires.setTime(dateExpires.getTime() + 720 * 60 * 60 * 1000);

export { dateExpires };
